import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export interface ExecutiveUser {
  username: string
  full_name: string
}

interface ExecutiveAuthState {
  user: ExecutiveUser | null
  token: string | null
  isAuthenticated: boolean
}

interface ExecutiveAuthActions {
  setAuth: (user: ExecutiveUser, token: string) => void
  clearAuth: () => void
}

export const useExecutiveAuthStore = create<ExecutiveAuthState & ExecutiveAuthActions>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setAuth: (user, token) => set({ user, token, isAuthenticated: true }),
      clearAuth: () => set({ user: null, token: null, isAuthenticated: false }),
    }),
    {
      name: 'ircs-executive-auth', // separate localStorage key — zero collision with Employee
      storage: createJSONStorage(() => localStorage),
    }
  )
)
